import React, { useState } from "react";

const CustomIntroduction = ({ formData, setFormData }) => {
  const [introImageUrl, setIntroImageUrl] = useState("");
  const [introImageText, setIntroImageText] = useState("");

  const optionsBassins = [
    { label: "Rhône-Méditerranée", value: "rhone" },
    { label: "Adour-Garonne", value: "adour" },
    { label: "Loire-Bretagne", value: "loire" },
    { label: "Rhine-Meuse", value: "rhin" },
    { label: "Seine-Normandie", value: "seine" },
    { label: "Artois-Picardie", value: "artois" },
  ];

  const autoResize = (e) => {
    e.target.style.height = "auto";
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleAddIntroImage = () => {
    if (!introImageUrl) return;

    setFormData((prev) => ({
      ...prev,
      intro_img_list: [
        ...prev.intro_img_list,
        { url: introImageUrl, text: introImageText },
      ],
    }));

    setIntroImageUrl("");
    setIntroImageText("");
  };

  const handleRemoveIntroImage = (index) => {
    const updated = formData.intro_img_list.filter((_, i) => i !== index);
    setFormData({ ...formData, intro_img_list: updated });
  };

  const handleUpdateIntroText = (index, newText) => {
    const updated = [...formData.intro_img_list];
    updated[index] = { ...updated[index], text: newText };
    setFormData({ ...formData, intro_img_list: updated });
  };

  const handleCustomIntroChange = (e) => {
    const checked = e.target.checked;
    setFormData((prev) => ({
      ...prev,
      custom_intro: checked,
      intro_img_list: checked ? prev.intro_img_list : [],
      bassin_intro: checked ? "" : prev.bassin_intro,
    }));
  };

  const moveSlideUp = (index) => {
    if (index === 0) return;
  
    const updated = [...formData.intro_img_list];
    [updated[index - 1], updated[index]] = [
      updated[index],
      updated[index - 1],
    ];
  
    setFormData({ ...formData, intro_img_list: updated });
  };
  
  const moveSlideDown = (index) => {
    if (index === formData.intro_img_list.length - 1) return;
  
    const updated = [...formData.intro_img_list];
    [updated[index + 1], updated[index]] = [
      updated[index],
      updated[index + 1],
    ];
  
    setFormData({ ...formData, intro_img_list: updated });
  };
  

  return (
    <div>
      <div className="custom-intro-group">
        <label>Introduction personnalisée :</label>
        <input
          type="checkbox"
          checked={formData.custom_intro}
          onChange={handleCustomIntroChange}
        />
      </div>

      {formData.custom_intro ? (
        <>
          {/* ➕ AJOUT IMAGE */}
          <div className="custom-intro-group">
            <input
              type="text"
              value={introImageUrl}
              onChange={(e) => setIntroImageUrl(e.target.value)}
              placeholder="URL de l’image"
              className="custom-intro-input"
            />

            <textarea
              value={introImageText}
              onChange={(e) => setIntroImageText(e.target.value)}
              onInput={autoResize}
              placeholder="Texte affiché sur l’image (optionnel)"
              className="custom-intro-textarea"
              rows={2}
            />

            <button
              type="button"
              onClick={handleAddIntroImage}
              className="custom-intro-add-button"
            >
              Ajouter
            </button>
          </div>

          {/* 📚 LISTE DES SLIDES */}
          <div className="custom-intro-img-list">
            <h4>Slides d'introduction</h4>

            {formData.intro_img_list.map((img, index) => (
              <div key={index} className="custom-intro-slide">
                {/* 🖼 PREVIEW */}
                <div className="custom-intro-upper-slide">
                <a
                  href={img.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                 
                  <img
                    src={img.url}
                    alt={`Slide ${index + 1}`}
                    className="custom-intro-preview"
                  />
                </a>

                {/* 📝 TEXTE */}
                <textarea
                  value={img.text || ""}
                  onChange={(e) =>
                    handleUpdateIntroText(index, e.target.value)
                  }
                  onInput={autoResize}
                  placeholder="Texte affiché sur cette image"
                  className="custom-intro-textarea"
                  rows={2}
                />

                <div className="custom-intro-slide-actions">
                  <button
                    type="button"
                    onClick={() => moveSlideUp(index)}
                    disabled={index === 0}
                    className="slide-move-button"
                  >
                    ⬆️
                  </button>

                  <button
                    type="button"
                    onClick={() => moveSlideDown(index)}
                    disabled={index === formData.intro_img_list.length - 1}
                    className="slide-move-button"
                  >
                    ⬇️
                  </button>
                </div>

                </div>
                

                <button
                  type="button"
                  onClick={() => handleRemoveIntroImage(index)}
                  className="custom-intro-remove-button"
                >
                  Supprimer
                </button>
              </div>
            ))}
          </div>
        </>
      ) : null}
    </div>
  );
};

export default CustomIntroduction;
